<template>
  <section class="sucess" id="failed-page">
    <div class="page-banner orders-banner success-banner">
      <el-row>
        <el-col :lg="24">
          <div class="image">
            <img
              src="/img/page-banners/success.jpg"
              alt="storeLocator-page-banner"
              class="img-fluid"
            />
          </div>
          <div class="banner-cover">
            <div class="banner-cover-inner">
              <div class="banner-image">
                <img src="/img/icons/failed.png" alt="icon" class="img-fluid" />
              </div>
              <div class="success-text">
                <h3>We’re Sorry.</h3>
                <p>Your order was Failed</p>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <App-StoreFilter />
    </div>
  </section>
</template>

<script>
import AdminDefault from "@/layouts/AdminDefault";

export default {
  name: "sucess",
  created() {
    this.$emit("update:layout", AdminDefault);
  }
};
</script>
<style scoped lang="scss">
#failed-page {
  .success-banner {
    .image {
      img {
        min-height: 100vh;
      }
    }
  }
  .banner-cover {
    background: rgba(255, 255, 255, 0.8) !important;
  }
  .banner-cover-inner {
    text-align: center;
    .banner-image {
      img {
        width: 90px;
        display: table;
        margin: 0 auto;
      }
    }
    .success-text {
      margin-top: 2.5em;
      h3 {
        font-size: 2.5em;
        margin-bottom: 10px;
        text-align: center;
        letter-spacing: 3px;
        color: #313131;
      }
      p {
        font-size: 1.1em;
        line-height: 1.4em;
        text-align: center;
        letter-spacing: 3px;
        color: #7b7a7a;
      }
    }
  }
}
</style>